import React from "react";
/* eslint-disable */
import {
    Box, TableBody, TableCell, TableContainer, TableHead, TableRow, Table
} from '@material-ui/core';
import moment from "moment";
export default class ComponentToPrint extends React.Component {

    render() {
        const grnDetails = this.props.grnDetails;
        const data = this.props.searchData;
        const totalValues = this.props.totalValues;
        return (
            <div align='left'>
                <h3><center><u>GRN Summary Details Report</u></center></h3>
                <div >&nbsp;</div>
                {/* <h4><center>Group - {data.groupID}</center></h4>
                <h4><center>Fresh Collection Center - {data.operationEntityID}</center></h4>
                <h4><center>Product Name (SKU Description) - {data.productID}</center></h4>
                <h4><center>Date - {data.date} </center></h4> */}
                <div>&nbsp;</div>
                <Box minWidth={1150}>

                    <TableContainer>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">Date</TableCell>
                                    <TableCell align="center">Fresh Collection Center</TableCell>
                                    <TableCell align="center">SKU Description</TableCell>
                                    <TableCell align="center">SKU Code</TableCell>
                                    <TableCell align="right">Net Amount(Received Qty)</TableCell>
                                    <TableCell align="right">Value (Rs.)</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {grnDetails.map((row) => (
                                    <TableRow key={row.productCode}>
                                        <TableCell align="center">
                                            {moment(new Date(row.grnDate)).format('YYYY-MM-DD')}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row.factoryName}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row.productName}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row.productCode}
                                        </TableCell>
                                        <TableCell align="right">
                                            {parseFloat(row.netAmount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                        </TableCell>
                                        <TableCell align="right">
                                            {parseFloat(row.value).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                        </TableCell>
                                    </TableRow>
                                ))}
                                <TableRow>
                                    <TableCell sx={{ fontWeight: "bold" }} align="center" colSpan={4}>
                                        Total
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: "bold" }} align="right">{parseFloat(totalValues.totalReceivedQty).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</TableCell>
                                    <TableCell sx={{ fontWeight: "bold" }} align="right">{parseFloat(totalValues.totalValue).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </div>

        );
    }
}
